module.exports = __webpack_public_path__ + "img/Revisi-Testimoni.e1e5a362.png";